import { useState, useEffect } from "react";

export function useIsScrollPositionTop(scrollContainer?: HTMLElement | null) {
  const [isAtTop, setIsAtTop] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const finalScrollContainer = scrollContainer || document.documentElement;
      setIsAtTop(finalScrollContainer.scrollTop === 0);
    };

    const finalScrollContainer = scrollContainer || document.documentElement;
    finalScrollContainer.addEventListener("scroll", handleScroll);
    return () => {
      finalScrollContainer.removeEventListener("scroll", handleScroll);
    };
  }, [scrollContainer]);

  return isAtTop;
}
